import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from "../../../js/ComponentManager";
import { RegisterCard } from '../../Common/RegisterCard';
/* 개발담당:양유빈
 * 화면기능:환불정책
 * 세부설명:
*/

export class RefundPolicy extends Component {
    static displayName = RefundPolicy.name;

    constructor(props) {
        super(props);

        let rfud_dt = format(Big3Common.Util.DateAdd(new Date(), 0), "yyyy-MM-dd");

        this.state = {
            Refund_Yn: "Y",
            Bill_Yn: "N",
            Clod_Point: "",
            Rfud_Price: "",
            Rfud_Dt: rfud_dt,
            rfud_comment: "",
            bank_nm: "",
            account_num: "",
            receiver: "",
            Agreement_Yn: false,
            Title: ""
        };

        /*this.handle_Click = this.handle_Click.bind(this);*/
        this.handle_Change = this.handle_Change.bind(this);
        this.RegisterCardRef = React.createRef();
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //초기화
    componentDidMount() {
        if (this.Uid_Type === 'TS') {
            /*this.GetRefund();*/
            this.GetbillingKey();
            /*this.GetPoint();*/
        }
    }
/*    //환불요청 확인
    async GetRefund() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetRefund", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Refund_Yn = DataList[0]["refund_yn"]
                this.setState({
                    Refund_Yn: Refund_Yn
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetRefundCount: ", e)
        }
        return false;
    }*/
    //카드등록확인
    async GetbillingKey() {
        try {
            //주문유형 
            let Data = await Big3Common.Post('api/Common/Common/GetbillingKey', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let Bill_Yn = "Y"
                this.setState({ Bill_Yn: Bill_Yn });

            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetbillingKey", e);
        }
        return false;
    }
/*    //포인트 조회
    async GetPoint() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetPoint", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Clod_Point = DataList[0]["total_point"];
                let Rfud_Price = "";

                if (Clod_Point > 10000) {
                    Rfud_Price = Clod_Point * 0.9;
                } else if (Clod_Point <= 10000) {
                    Rfud_Price = 1000;
                } else {
                    Rfud_Price = "";
                }

                this.setState({
                    Clod_Point: Clod_Point,
                    Rfud_Price: Rfud_Price
                });
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetPoint: ", e)
        }
        return false;
    }*/
    handle_Change(event) {
        const tagId = event.target.id;
        const value = event.target.value.trim();

        if (tagId === "rfud_comment") {
            this.setState({ rfud_comment: value });
        }
        else if (tagId === "bank_nm") {
            this.setState({ bank_nm: value });
        }
        else if (tagId === "account_num") {
            this.setState({ account_num: value });
        }
        else if (tagId === "receiver") {
            this.setState({ receiver: value });
        }
        else if (tagId === "Agreement_Yn") {
            const checked = event.target.checked;
            this.setState({ Agreement_Yn: checked });
        }
        return false
    }
/*    async handle_Click() {
        let AlertMsg = "";
        if (this.state.rfud_comment.trim() === "") {
            AlertMsg = "환불사유를 입력하세요."
        }
        else if (this.state.bank_nm.trim() === "") {
            AlertMsg = "은행명을 입력하세요."
        }
        else if (this.state.account_num.trim() === "") {
            AlertMsg = "계좌번호를 입력하세요."
        }
        else if (this.state.receiver.trim() === "") {
            AlertMsg = "수취인을 입력하세요."
        }
        if (AlertMsg !== "") {
            this.setState({ Title: AlertMsg });
            Big3Common.ModalAlert(bootstrap, "MessageAlert");
            return false;
        }
        try {
            let data = await Big3Common.Post("api/Common/Common/RegisterRefund", {
                rfud_comment: this.state.rfud_comment,
                bank_nm: this.state.bank_nm,
                account_num: this.state.account_num,
                receiver: this.state.receiver,
                rfuid_point: this.state.Clod_Point,
                rfud_price: this.state.Rfud_Price,
                rfud_dt: this.state.Rfud_Dt
            }, true);
            if (data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.ModalClose(bootstrap, 'Refundodal');
            }
            else {
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("handle_Click: ", e);
        }

    }*/
/*    handle_Refund = async (event) => {
        if (this.state.Agreement_Yn === false) {
            this.setState({ Title: "서비스 이용약관에 동의해주세요." });
            Big3Common.ModalAlert(bootstrap, "Alert");
        }
        else {
            Big3Common.ModalAlert(bootstrap, "Refundodal");
        }
        event.preventDefault();
    }*/
    handle_RegisterCard = async (event) => {
        if (this.state.Agreement_Yn === false) {
            this.setState({ Title: "서비스 이용약관에 동의해주세요." });
            Big3Common.ModalAlert(bootstrap, "Alert");
        }
        else {
            this.RegisterCardRef.current.requestPayment();
            Big3Common.ModalAlert(bootstrap, "RegisterCard");
        }
        event.preventDefault();
    }
/*    handle_CancleRefund = async (event) => {
        if (this.state.Agreement_Yn === false) {
            this.setState({ Title: "서비스 이용약관에 동의해주세요." });
            Big3Common.ModalAlert(bootstrap, "Alert");
        }
        else {
            try {
                let Data = await Big3Common.Post('api/Common/Common/CancleRefund', {}, true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    this.setState({ Title: "환불취소안내", Content: Data.message });
                    Big3Common.ModalAlert(bootstrap, 'Alert');
                    this.GetRefund();
                }
                else if (Data.codeName === Big3Common.ResultCode.Warning) {
                    this.setState({ Title: "환불취소안내", Content: Data.message });
                    Big3Common.ModalAlert(bootstrap, 'Alert');
                }
            }
            catch (e) {
                console.log("handle_CancleRefund", e);
            }
            return false;
        }
    }
    //환불요청 모달창
    RefundModalrender() {
        return (
            <div className="modal fade show" id="Refundodal" aria-modal="true" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content ordertype_modal">
                        <div className="modal-body text-center">
                            <div className="desc ordertype_modal_in">
                                <div className="modal_title">포인트환불</div>
                            </div>
                            <div className="refund_modal_box">
                                <div className="refund_info flex_sb">
                                    <div className="label">환불일자</div>
                                    <div className="info">{this.state.Rfud_Dt}</div>
                                </div>
                                <div className="refund_info flex_sb">
                                    <div className="label">잔여포인트</div>
                                    <div className="info">{Big3Common.Util.Money(this.state.Clod_Point)}P</div>
                                </div>
                                <div className="refund_info flex_sb">
                                    <div className="label">환불가능 금액</div>
                                    <div className="info">{Big3Common.Util.Money(this.state.Rfud_Price)}원</div>
                                </div>
                                <div className="refund_info refund_inputbox">
                                    <div className="label">환불사유</div>
                                    <textarea
                                        type="text"
                                        id="rfud_comment"
                                        placeholder="환불사유를 입력해주세요."
                                        onChange={this.handle_Change}
                                    >
                                    </textarea>
                                </div>
                                <div className="refund_info refund_inputbox">
                                    <div className="label">은행명</div>
                                    <input
                                        type="text"
                                        id="bank_nm"
                                        placeholder="은행명을 입력해주세요."
                                        onChange={this.handle_Change}
                                    />
                                </div>
                                <div className="refund_info refund_inputbox">
                                    <div className="label">계좌번호</div>
                                    <input
                                        type="text"
                                        id="account_num"
                                        placeholder="계좌번호를 입력해주세요."
                                        onChange={this.handle_Change}
                                    />
                                </div>
                                <div className="refund_info refund_inputbox">
                                    <div className="label">수취인</div>
                                    <input
                                        type="text"
                                        id="receiver"
                                        placeholder="수취인을 입력해주세요."
                                        onChange={this.handle_Change}
                                    />
                                </div>
                                <div className="flex_sb">
                                    <button type="button" className="btn_v2" data-bs-dismiss="modal" aria-label="Close">취소</button>
                                    <button type="button" className="btn_v1" onClick={this.handle_Click}>확인</button>
                                </div>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                </div>
                <Alert
                    id="MessageAlert"
                    title={this.state.Title}
                    content={this.state.Content}
                />
            </div>
        )
    }*/
    render() {
        /*const RefundModalrender = this.RefundModalrender()*/
        return (
            <div className="container_box p_margin c_padding">

                <p className="text_type2">작성일: 2024년 8월 23일</p><br />
                <p className="text_type4">본 약관은 클로디 서비스 이용 및 결제와 관련하여 필요한 사항을 규정합니다.</p><br />
                <p className="text_type4">제 1 장 총칙</p><br />
                <p className="text_type4">제 1 조 (목적)</p><br />

                <p className="text_type5">
                    본 약관은 클로디를 운영하는 주식회사 큰삼촌컴퍼니(이하 '회사'라 합니다)가 제공하는 서비스를 고객이 이용함에 있어 필요한 이용 조건,
                    절차 및 당사자간의 권리, 의무 등 기본적인 사항을 규정하는 것을 목적으로 합니다.
                </p><br />

                <p className="text_type4">제 2 조 (용어의 정의)</p><br />

                <p className="text_type5">
                    본 약관에서 사용하는 용어는 다음과 같이 정의합니다.<br />
                    <br />
                    1.	'고객'이란 본 약관에 동의하고 회사가 제공하는 서비스를 이용하는 자를 말합니다.<br />
                    <br />
                    2.	'회원'이란 고객 중 회사의 앱 등을 통해 이용 약관과 개인정보의 수집, 제공 및 활용에 관한 동의서에 동의한 자를 말합니다<br />
                    <br />
                    3.	'자동결제'란 최초 신용카드 등의 카드정보를 입력 후 요금이 청구되었을 때 별도의 인증과정 없이 자동으로 결제되는 것을 말합니다.<br />
                    <br />
                    4.	'클로디택배'란 회사가 제공하는 상품배송 서비스를 말합니다.<br />
                    <br />
                    5.	'택배삼촌'이란 배송 서비스를 제공하기 위해 도매매장에서 상품 수거를 담당한 인력을 말합니다.<br />
                    <br />
                    6.	'배송비'란 클로디택배 배송비용을 말합니다.<br />
                    <br />
                    7.	'처수비'란 택배삼촌이 도매매장에 방문해 상품을 수거할 때 발생하는 매장 별 수수료를 말합니다.<br />
                    <br />

                </p><br />

                <p className="text_type4">제 3 조 (약관의 효력 및 변경 등)</p><br />

                <p className="text_type5">
                    1.	본 약관은 그 내용을 회사가 홈페이지에 게시하고, 고객이 포인트를 충전 후 소지 또는 기타 정당한 방법으로 소지하여 사용함으로써 그 효력이 발생됩니다.<br />
                    <br />
                    2.	회사는 본 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 홈페이지에 그 적용일의 7일 전부터 공시하거나 회원이 입력한 가장 최근의 e-mail로 전송하는 방법으로 회원에게 고지합니다. 다만, 회원에게 불리한 내용으로 약관을 개정하는 경우에는 적용일로부터 30일 전까지 홈페이지에 공시하고 회원이 입력한 가장 최근의 e-mail로 전송하는 방법으로 회원에게 고지합니다.<br />
                    <br />
                    3.	본 조의 규정에 의하여 개정된 약관은 원칙적으로 그 변경되는 약관의 효력 발생일로부터 장래를 향하여 유효합니다.<br />
                    <br />
                    4.	고객이 변경된 약관 사항에 동의하지 않을 경우, 약관의 효력 발생 전일까지 서비스 이용을 중단하거나 회원탈퇴 및 등록된 포인트를 고객이 계정에서 등록 해지함으로써 이용 계약을 해지할 수 있으며, 약관의 개정과 관련하여 효력 발생일 전일까지 이의를 제기하지 않는 경우에는 개정된 약관에 동의한 것으로 간주합니다.<br />
                    <br />


                </p><br />

                <p className="text_type4">제 4 조 (약관의 해석 등)</p><br />

                <p className="text_type5">
                    본 약관에 명시되지 않은 사항 또는 본 약관 해석상 다툼이 있는 경우에는 고객과 회사의 합의에 의하여 결정합니다.
                    다만, 합의가 이루어지지 않은 경우에는 관계법령 및 거래관행에 따릅니다.<br />
                    <br />
                    
                </p><br />

                <p className="text_type4">제 2 장 자동결제 서비스</p><br />
                <p className="text_type4">제 5 조 (서비스 이용요금 및 지불방법)</p><br />

                <p className="text_type5">
                    1.	서비스 이용요금<br />
                    <br />
                    가)	클로디는 서비스 이용요금을 고객이 쉽게 알 수 있도록 앱에 게시합니다. 이용요금은 이벤트 및 프로모션 등 회사의 정책과 파트너와의 제휴 관계 등에 따라 별도의 고지 없이 변경될 수 있습니다.<br />
                    <br />
                    나)	처수비와 배송비는 정확한 산정을 위해 상품 수거 후 클로디의 검수를 거쳐 요금이 안내됩니다.<br />
                    <br />
                    다)	회사는 서비스 이용요금을 앱 및 카카오톡 메시지를 통해 고객에게 통지하며, 클로디택배를 수령하기 전 이용요금을 지불하는 것을 원칙으로 합니다.<br />
                    <br />
                    라)	서비스 이용요금은 회사가 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있으며, 결제된 대금에 대한 취소 및 환불은 해당 약관 등 관계법에 따릅니다.<br />
                    <br />
                    2.	지불방법<br />
                    <br />
                    가)	서비스 이용요금 지급방법은 자동결제 또는 기타 정당한 방법으로 합니다.<br />
                    <br />
                    나)	클로디는 고객의 편의를 위해 자동결제 서비스를 제공합니다. 결제카드를 등록한 고객은 서비스 이용요금을 별도의 인증과정 없이 자동으로 결제하겠다는 의사표시를 한 것으로 봅니다.<br />
                    <br />
                    다)	고객이 등록한 결제카드 등의 유효성, 한도 등의 문제로 결제가 실패하여 이용요금 결제가 되지 않을 경우 미수로 처리되며, 해당 주문 배송은 보류됩니다.<br />
                    <br />
                    라)	미납금이 일정기간 계속하여 변제되지 않을 경우에는 서비스 이용이 제한되며 회원자격이 박탈될 수 있습니다. 서비스 사용 중지 또는 회원자격 박탈에 대한 판단 기준은 회사의 운영약관에 근거합니다.<br />
                    <br />

                </p><br />

                <p className="text_type4">제 6 조 (서비스의 이용제한)</p><br />

                <p className="text_type5">
                    1.	다음에 해당할 경우 사전 경고 없이 고객의 서비스 이용을 제한하거나, 정도에 따라 해지할 수 있습니다.<br />
                    <br />
                    가)	상품주문 후 일방적으로 취소하는 경우.<br />
                    <br />
                    나)	상품수거 완료 후 서비스 이용요금을 미결제하는 경우.<br />
                    <br />
                    다)	정상적인 서비스 이용으로 볼 수 없는 다량의 계정 생성 및 서비스 가입/탈퇴, 반복적 유사 활동.<br />
                    <br />
                    라)	기타 건전한 서비스 환경 제공에 악영향을 끼치는 경우<br />
                    <br />
                    마)	고의로 미납금을 발생시킨 것으로 판단되는 경우<br />
                    <br />
                    바)	기타 합리적인 판단에 의하여 서비스의 제공을 거부할 필요가 있다고 회사가 인정할 경우<br />
                    <br />
                    2.	클로디가 회원계약을 해지하는 경우 회사는 고객에게 해지 사유를 밝혀 해지 의사를 통지합니다. 이 경우 회사는 해지를 하기전에 상당한 기간을 정하여 고객에게 이의 신청의 기회를 부여합니다. 다만, 회사의 이용약관에서 정하는 사유가 있을 경우에는 별도의 이의 신청 기간을 부여하지 않을 수 있습니다.<br />
                    <br />
                    3.	회원계약이 회사에 의해 해지되는 경우 고객의 재이용 신청에 대해 회사는 승낙을 거절할 수 있습니다. 고객의 귀책사유로 인해 회원계약이 해지됨으로써 발생한 손해는 고객이 부담하게 되며, 회사는 관련 법령에 규정이 없는 한 책임을 부답하지 않습니다.<br />
                    <br />

                </p><br />

                <p className="text_type4">제 7 조 (취소와 환불)</p><br />

                <p className="text_type5">
                    1.	서비스 이용요금에 대한 취소 및 환불 규정은 전자상거래 등에서의 소비자 보호에 관한 법률 등 관련 법령을 준수합니다. 다만, 도매매장에서 수거 후 배송하는 특수성에 따라 상품이 클로디택배 센터에 입고된 이후에는 클로디와 택배삼촌에게 회복할 수 없는 손해가 발생하므로 사전에 안내된 단순변심, 가격에 대한 이의, 배송 예정일 등에 의한 취소 및 환불은 불가합니다.<br />
                    <br />
                    2.	클로디는 고객의 상품을 모두 배송하기 위해 최선을 다하고 있습니다. 다만, 도매매장의 미송 상품을 배송하는 것은 어려운만큼 미송 상품이 배송되지 않았다 하더라도 나머지 배송상품에 대한 이용요금은 환불되지 않습니다.<br />
                    <br />
                    3. 클로디 택배는 후불결제 서비스로 이미 제공된 서비스에 대하여 결제취소 또는 환불이 불가합니다.<br />
                    <br />

                </p><br />

                <p className="text_type4">(부칙)</p><br />

                <p className="text_type5">
                    본 이용약관은 2024년 8월 23일부터 시행합니다.
                    <br />

                </p><br />

                {
                    this.Uid_Type === 'TS' ?
                        <>
                            <div className="agree_line">
                                <div className="agree_line_in">
                                    <input className="form-check-input"
                                        type="checkbox"
                                        id="Agreement_Yn"
                                        onChange={this.handle_Change}
                                        checked={this.state.Agreement_Yn}
                                    />
                                    <label className="form-check-label">
                                        위의 약관에 모두 동의합니다.
                                    </label>
                                </div>
                            </div>
                            {/*<div>
                                {this.state.Refund_Yn === 'N' && this.state.Bill_Yn === 'Y' ?
                                    <button className="refund_btn" onClick={(e) => { this.handle_Refund(e); }}>환불하기</button>
                                    :
                                    <button className="cancle_btn" onClick={(e) => { this.handle_CancleRefund(e); }}>환불취소</button>
                                }
                            </div>*/}
                            <button className="refund_btn abtn_v1" onClick={(e) => { this.handle_RegisterCard(e); }}>카드등록</button>
                        </>
                        :
                        <></>
                }
                
                {/*{RefundModalrender}*/}
                <RegisterCard id="RegisterCard"
                    ref={this.RegisterCardRef}
                />
                <Alert
                    id="Alert"
                    title={this.state.Title}
                    content={this.state.Content}
                />
            </div>
        );
    }
}
